module.exports = "<span class=\"icon-container\"></span>\n<div class=\"content\">\n  <div class=\"text\">\n    <h3 class=\"title -sub\">\n      <strong>{{ 'appointment.reminder_notice_title' | translate }}</strong>\n    </h3>\n    <p [innerHTML]=\"getReminderText()\"></p>\n  </div>\n</div>\n<div class=\"action\">\n  <button (click)=\"editReminders()\" class=\"hollow-button\">{{ 'actions.btn_edit' | translate }}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/main/appointments/appointments-reminder/appointments-reminder.component.html
// module id = 1246
// module chunks = 0